import { Component, NgZone, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EventsService } from 'angular4-events';
import { UserService } from '../../../service/security-access/user.service';

declare function hideNavsOnScroll(): any;

@Component({
  selector: 'app-offer-nav',
  templateUrl: './offer-nav.component.html',
  styleUrls: ['./offer-nav.component.css']
})
export class OfferNavComponent implements OnInit {
  isAuthenticated: boolean;

  constructor(
    private userService: UserService,
    private events: EventsService,
    private zone: NgZone,
    private router: Router
  ) { }

  ngOnInit() {
    this.isAuthenticated = this.userService.isAuthenticated();
    this.events.subscribe('updateMiCuenta', () => {
      this.zone.run(() => {
        this.isAuthenticated = this.userService.isAuthenticated();
      });
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isAuthenticated = this.userService.isAuthenticated();
      }
    });
    hideNavsOnScroll();
  }

}
